import React from "react";
import Layout from "./layout";

export default function authenticatedLayout(Component) {
  return function finalAuthenticatedLayout() {
    return (
      <Layout>
        <Component />
      </Layout>
    );
  };
}
